export default __webpack_public_path__ + "static/media/NCoder.a7a2dc7a.jpg";